import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { Component, ElementRef, Injector, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { PipeColumn } from '../models/pipe.model';
import { qDragAndDropCallback } from '../../services';
import { PipeBaseComponent } from '../pipe-base/pipe-base.component';
import { BaseQueovalItem, BreadcrumbModel, ParamApplication, QResult } from '../../models';
import { PipeDisplayMode } from '../pipe-base/pipe.model';
import { FormationModel, Training } from '../models/pipe-catalogue.model';

@Component({
  selector: 'q-comp-pipe-catalogue',
  templateUrl: './pipe-catalogue.component.html',
  styleUrls: ['./pipe-catalogue.component.css', '../pipe-base/pipe-base.component.css']
})
export class PipeCatalogueComponent extends PipeBaseComponent implements OnInit {
  //Pour l'instant ça marche avec la version 14 d'angular mais seul Dieu sait si cela sera le cas dans le futur
  //Si ça ne marche plus avec les nouvelles versions ..... bon chance
  constructor(injector: Injector) {
    super(injector);

    //Prefix de la route du controlleur
    this.configParam.routePrefix = 'api/Pipe/Catalogue/'

    //Nom du bo dans lequel où se trouve la propriété qui va définir les colonnes
    this.configParam.columnDefinition.codeBo = 'BO_FORMATION';
    //Nom propriété qui va définir les colonnes
    this.configParam.columnDefinition.codeProperty = 'ColPiFOR';

    //Table dans la quelle la propriété qui definit les colonnes se trouve
    this.configParam.columnDefinition.tablePrefix = 'formation';
    //Alias de la table dans la quelle la propriété qui definit les colonnes se trouve (propablement optimisable pour marcher sans)
    this.configParam.columnDefinition.tableName = 'tDOFormation';
    //Potentiel ordre par défaut de la requête
    this.configParam.columnDefinition.columnOrderBy = '';
    //Permets de définir des colonnes supplémentaires à ajouter à la fin du pipe, ne marche que avec des conditions custome de requete (PropInWhere:false)
    this.configParam.columnDefinition.extraColumn = [];
    //Exemple:
    //l[{ Text: 'Nom colonne', PropKey: 'idConditionRequete', PropInWhere: false, PropOperator: Operator.Egale, PropType: FilterPropertyType.Select, }]


    //Nom de la grid qui va servir de modele
    this.configParam.gridModel = 'CatalogueList';


    //GroupAPL pour enregistrer ou recuperer les configurations des colonnes  (tPAApplication)
    this.configParam.columnDefinition.columnFilterGroupe = 'COLPIPECATALOGUE';


    //Affiche ou non la barre de recherche
    this.configParam.quickSearch.show = true;

    //Definition de la liste des options de recherche pour la quickSearch
    this.configParam.quickSearch.data = [
      { titre: `Formation ou Code Formation`, mode: 'FOR', tableName: 'tDOFormation', propSearchName: 'IdentFOR,Info_FOR', relationName: 'REL_BO_CENT_BO_FORMATION', isBoPere: false, key: 'formation.Ident' },
      { titre: 'Action ou Code Action', mode: 'ACT', tableName: 'tDOAction', propSearchName: 'IdentACT,Info_ACT', relationName: 'REL_BO_FORMATION_BO_ACTION', isBoPere: false, key: 'action.Ident' },
    ];



    //Active ou non les filtres 
    this.configParam.filter.show = true;
    //GroupMOD pour enregistrer ou recuperer les modeles des filtres (tPAModele)
    this.configParam.filter.modelGroup = 'CATALOGUE_FILTRE';

  }

  //Obligatoire ne marche pas s'ils ne sont pas définis ici (merci angular de ne pas comprendre intérêt de l'héritage =3)
  //@ViewChildren('ScrollViewport') viewPorts: QueryList<CdkVirtualScrollViewport>;
  @ViewChild('modalSettingColumn') modalSettingColumn: ElementRef;
  modalTemplate: TemplateRef<any>;

  //Zone des templates
  //Permet de maper les differents templates avec le composant (les html sont definis dans le html de la base)
  //Supprimer la ligne s'il n'est pas utilisé
  @ViewChild('cardCatalogue') cardTemplate: TemplateRef<any>;
  @ViewChild('footerCatalogue') footerTemplate: TemplateRef<any>;
  @ViewChild('btnCatalogue') btnTemplate: TemplateRef<any>;


  formationDefaultExist: string;

  //S'execute apres que le ngAfterViewInit de la base
  protected afterBaseInit() {   
    this.http.getHttp<QResult<string>>(`${this.indParam.AppParams.apiUrl}api/Pipe/Catalogue/GET_DEFAULT_FORMATION_IDENT`).subscribe((result: QResult<string>) => {
      this.formationDefaultExist = result.Value;
    });
  }

  //Recupere l'evenement du click sur les cartes du pipe 
  protected cardClickCallBack(data: qDragAndDropCallback) {

    this.openCatalogue(data.ident);
  }
  //Recupere l'evenement du drop des cartes du pipe 
  protected afterDropCallBack(data: qDragAndDropCallback) {
  }

  public openSettingCol() {

    this.currentColumnModel = new ParamApplication();
    this.selectedColumn = new Array<string>();

    this.http.postHttp<QResult<Array<BaseQueovalItem>>>(`${this.indParam.AppParams.apiUrl}${this.configParam.routePrefix}Column/LIST_ALL_COLUMN`, this.configParam.columnDefinition).subscribe(
      (data: QResult<Array<BaseQueovalItem>>) => {
        this.columnList = data.Value;
      });

    this.http.postHttp<QResult<Array<ParamApplication>>>(`${this.indParam.AppParams.apiUrl}${this.configParam.routePrefix}Column/LIST_MODEL_COLUMN`, this.configParam.columnDefinition).subscribe(
      (data: QResult<Array<ParamApplication>>) => {
        this.columnModelList = data.Value;
      });
    this.modalService.open(this.modalSettingColumn, { centered: true, size: 'lg', windowClass: 'qmodalover' });
  }

  //Recupere les evenements de la grid
  protected gridClickCallBack(res: any) {
    if (res.Value.includes(';')) {
      let id = res.Value.split(';')
      this.openCatalogue(id[0], id[1]);
    } else {
      this.openCatalogue(res.Value);
    }
  }


  //S'execute juste avant la recuperation des cartes du pipe/grid
  //permet de faire du pretraitement de données avant la requete
  protected beforeGetCards() {
  }

  //S'execute juste apres la recuperation des cartes du pipe
  //permet de faire du posttraitement de données apres la requete
  protected afterGetCardsPipe(columns: Array<PipeColumn> | undefined = undefined) {
  }

  //S'execute juste apres la recuperation des cartes de la grid
  //permet de faire du posttraitement de données apres la requete
  //la liste des idents filtrées est passé en paramètre pour filtrer les requête en posttraitement
  protected afterGetCardsGrid(filtredIdent: String[] | undefined = undefined) {
    //Pour update les valeurs de la gird il faut affecter une datatable a la variable 'this.gridUpdateValue'
    //cette datatable doit obligatoirement contenir une propriété ident afin de faire le pivot avec les données de la grid    
  }



  private openCatalogue(idCatalogue: string, idAction: string | null = null) {
    this.saveNavigationParam();
    if (idAction) {
      this.breadcrumb.call(new BreadcrumbModel('add', `view/formations/formations-detail/${idCatalogue}/${idAction}`, null, 'Catalogue', true));
    } else {
      this.breadcrumb.call(new BreadcrumbModel('add', `view/formations/formations-detail/${idCatalogue}`, null, 'Catalogue', true));
    }

  }



  public createFormation($event: any, col: PipeColumn, colId: any) {
    const model: FormationModel = new FormationModel();
    model.Mode = 'CREATE_FORMATION';
    model.SelectedTraining = new Training();
    model.SelectedTraining.ColumnPipe = col.columnSelector[0].PropValue;

    this.http.postHttp<any>(`${this.indParam.AppParams.apiUrl}api/formation/`, model).subscribe((result: any) => {
      if (!result.HasError) {
        this.saveNavigationParam();
        this.breadcrumb.call(new BreadcrumbModel('add', `view/formations/formations-detail/${result.SelectedTraining.Ident}`, null, 'Catalogue', true));
      }
    });
  }
}


